<script setup>
import PreviewPanel from '@/components/SingleFileViewComponent.vue';
import ToastComponent from '@/components/ToastComponent.vue';
import { useAxios } from '@/hooks/useAxios';
import { computed, onMounted, ref, watch } from 'vue';
let BASE_URL = import.meta.env.VITE_APP_API_URL;

// Props 정의
const props = defineProps({
    modelValue: {
        type: [Array, Object, String],
        default: () => []
    },
    inputId: {
        type: String,
        default: ''
    },
    fileId: {
        type: String,
        default: ''
    },
    category: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false
    },
    placeholder: {
        type: String,
        default: '클릭하여 파일을 선택하세요.' //'파일을 선택하세요. (PDF, JPEG, JPG, PNG, GIF, BMP 파일만 업로드 가능합니다.)'
    },
    disabled: {
        type: Boolean,
        default: false
    },
    marginTop: {
        type: String,
        default: '0'
    },
    marginBottom: {
        type: String,
        default: '0'
    },
    marginLeft: {
        type: String,
        default: '0'
    },
    marginRight: {
        type: String,
        default: '0'
    },
    labelRightmargin: {
        type: String,
        default: '2rem'
    },
    visible: {
        type: Boolean,
        default: true
    },
    button: {
        type: String,
        default: ''
    },
    errmsg: {
        type: String,
        default: ''
    },
    readonly: {
        type: Boolean,
        default: false
    },
    height: {
        type: String,
        default: '8rem'
    },
    single: {
        type: Boolean,
        default: false
    }
    // updateComponentState: {
    //     type: [Array, Function],
    //     default: () => []
    // }
});

// Emits 정의
const emit = defineEmits(['update:modelValue', 'change', 'click']);
const allowedFileTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']; // , 'image/gif', 'image/bmp'
const allowedExtensions = ['.pdf', '.jpeg', '.jpg', '.png', '.gif', '.bmp'];
//const fileUploads = inject('fileUploads');
//const handleFileUpload = inject('handleFileUpload');
const fileIdRef = ref(props.fileId);
const categoryRef = ref(props.category);
const filenameRef = ref(props.filename);
const originalnameRef = ref(props.originalname);
const errorstate = ref(false);
const toastComponentRef = ref(null);
const ValidationMsg = ref('');
const isReadonly = computed(() => props.readonly);
const errMessage = ref(props.errmsg);
const previewFile = ref({
    url: '',
    type: ''
});
const downloadFile = ref({
    url: ''
});

// 내부 상태 관리
const selectedFiles = ref([]); // 선택된 파일
const fileInput = ref(null);
const isDnDEnabled = computed(() => !isReadonly.value && !props.disabled && !errorstate.value);

onMounted(async () => {
    // fileIdRef.value = 'f95f-5a5d-c08f-34ab';
    // setFile();
});

const handleFileSelect = (event) => {
    // console.log(selectedFiles.value);
    if (!isDnDEnabled.value) return;
    if (props.single && selectedFiles.value.length >= 1) {
        //delete가 1개라도 있을경우  있을경우
        let gubn = selectedFiles.value.some((s, i) => s.delete === false);
        if (gubn) {
            toastComponentRef.value?.showToast('error', '알림', '파일은 1개만 등록가능합니다');
            return;
        }
    }
    const files = Array.from(event.target.files);
    handleFiles(files);
    event.target.value = '';
};

const removeFile = (index, uploaded, del) => {
    if (props.single && !del && selectedFiles.value.length > 1) {
        toastComponentRef.value?.showToast('error', '알림', '파일은 1개만 등록가능합니다.등록된 파일을 삭제 후 원복가능합니다.');
        return;
    }
    if (!uploaded) {
        selectedFiles.value.splice(index, 1);
    } else {
        selectedFiles.value[index].delete = del;
        // ValidationMsg.value = '저장 후 파일이 삭제됩니다.';
    }
    emit('change', selectedFiles.value);
    emit('update:modelValue', selectedFiles.value);
};

const removeAllFiles = () => {
    selectedFiles.value = [];
    emit('update:modelValue', selectedFiles.value);
};

const triggerFileInput = () => {
    if (isReadonly.value || errorstate.value) return;
    if (!props.disabled) {
        fileInput.value?.click();
    }
};

const handleFilePreview = async (filename) => {
    if (filename) {
        try {
            const response = await fetch(`${BASE_URL}/view/${filename}`);
            if (response.ok) {
                previewFile.value = {
                    url: `${BASE_URL}/view/${filename}`,
                    type: response.headers.get('content-type'),
                    downurl: `${BASE_URL}/download/${filename}`
                };
            }
        } catch (error) {
            console.error('Error previewing file:', error);
            toastComponentRef.value?.showToast('error', '알림', '파일 미리보기 중 오류가 발생했습니다.');
        }
    }
};

const closePreview = () => {
    previewFile.value = { url: '', type: '' };
};

const setFile = () => {
    if (fileIdRef.value === '') {
        selectedFiles.value = [];
        emit('update:modelValue', selectedFiles.value);
        return;
    }
    errorstate.value = false;
    try {
        let url = `/upload/images/${fileIdRef.value}`;
        if (categoryRef.value !== '') url = url + `?category=${categoryRef.value}`;
        const config = {
            method: 'get'
        };
        const { data, error, execute } = useAxios(url, config, {
            immediate: false,
            onSuccess(response) {
                // console.log(props.inputId, ' ', response.data.data);
                const files = response.data.data.map((item) => ({
                    fileid: item.attachment_id,
                    filename: item.attachment_filename,
                    name: item.original_filename,
                    uploaded: true,
                    delete: false
                }));

                // selectedFiles에 추가
                selectedFiles.value = files; // selectedFiles.value = [...selectedFiles.value, ...files];
                //console.log(selectedFiles.value);
                emit('update:modelValue', selectedFiles.value);
            },
            onError(err) {
                console.error('Error:', err.message);
                errorstate.value = true;
                originalnameRef.value = '파일을 찾을 수 없습니다.';
                ///clearFiles();
            }
        });

        execute();
    } catch (error) {
        console.error('파일 조회 오류 발생:', error);
    }
};

const downloadFiles = (filename) => {
    const fileUrl = `${BASE_URL}/download/${filename}`;
    window.open(fileUrl, '_self');
    setTimeout(() => {
        downloadFile.value = { url: '' };
    }, 300);
};

const downloadAllFiles = () => {
    if (!props.disabled) {
        const fileUrl = `${BASE_URL}/download/files/${fileIdRef.value}`;
        window.open(fileUrl, '_self');
        setTimeout(() => {
            downloadFile.value = { url: '' };
        }, 300);
    }
};

const deletedCount = computed(() => {
    if (selectedFiles.value.length === 0) return 0;
    return Array.isArray(selectedFiles.value) ? selectedFiles.value.filter((file) => file.delete === true).length : 0;
});

const uploadedCount = computed(() => {
    if (selectedFiles.value.length === 0) return 0;
    return Array.isArray(selectedFiles.value) ? selectedFiles.value.filter((file) => file.uploaded === true).length : 0;
});

const isDragging = ref(false);

const handleDrop = (event) => {
    isDragging.value = false;
    if (!isDnDEnabled.value) return;
    const files = Array.from(event.dataTransfer.files);
    handleFiles(files);
};

const handleFiles = (files) => {
    if (!isDnDEnabled.value) return;

    if (!Array.isArray(selectedFiles.value)) {
        selectedFiles.value = [];
    }

    ValidationMsg.value = '';
    errMessage.value = '';
    errorstate.value = false;

    for (const file of files) {
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        const isValidType = allowedFileTypes.includes(file.type) || allowedExtensions.includes(fileExtension);

        if (!isValidType) {
            toastComponentRef.value?.showToast('error', '알림', '허용되지 않는 파일 형식입니다. PDF, JPEG, JPG, PNG 파일만 업로드 가능합니다.');
            continue;
        }

        selectedFiles.value.push({
            file,
            fileid: props.fileId || '',
            filename: '',
            name: file.name,
            size: (file.size / 1024).toFixed(2),
            uploaded: false,
            delete: false
        });
    }

    emit('update:modelValue', selectedFiles.value);
    emit('change', selectedFiles.value);
};

const handleDragOver = () => {
    if (!isDnDEnabled.value) return;
    isDragging.value = true;
};

const handleDragLeave = () => {
    if (!isDnDEnabled.value) return;
    isDragging.value = false;
};

watch(
    () => props.modelValue,
    (newVal) => {
        if (!Array.isArray(newVal)) {
            selectedFiles.value = [];
            return;
        }

        if (newVal.length === 0) {
            selectedFiles.value = [];
            return;
        }

        if (newVal !== selectedFiles.value) {
            selectedFiles.value = newVal;
        }
    },
    { immediate: true }
);

// watch(
//     () => fileUploads.value[props.inputId],
//     (newResult) => {
//         if (newResult && newResult.option === 'upload') {
//             fileIdRef.value = newResult.fileid;
//             filenameRef.value = newResult.filename;
//             originalnameRef.value = newResult.originalname;
//             setFile();
//         }

//         if (newResult && newResult.option === 'remove') {
//             clearFiles();
//         }
//     }
//     // { deep: true }
// );

watch(
    () => props.fileId,
    (newVal) => {
        fileIdRef.value = newVal;
        setFile();
    },
    { deep: true }
);

watch(
    () => props.errmsg,
    (newVal) => {
        ValidationMsg.value = newVal || '';
        errMessage.value = newVal || '';
    },
    { immediate: true, deep: true }
);

defineExpose({
    removeAllFiles,
    selectedFiles,
    fileIdRef
});
</script>

<template>
    <div
        class="flex flex-col"
        :style="{
            marginTop,
            marginBottom,
            marginLeft,
            marginRight
        }"
    >
        <ToastComponent ref="toastComponentRef" />
        <PreviewPanel v-if="previewFile.url" :fileUrl="previewFile.url" :fileType="previewFile.type" :downurl="previewFile.downurl" @close="closePreview" />

        <div v-if="label" class="label justify-between">
            <div class="flex items-center">
                {{ label }}
                <span v-if="required" class="required-asterisk">*</span>
                <span v-if="ValidationMsg" class="validation-message">{{ ValidationMsg }}</span>
            </div>

            <div class="select-count">
                <template v-if="!isReadonly">
                    <button v-if="uploadedCount > 0" @click.stop="downloadAllFiles" class="upload-button mr-2" :class="{ disabled: disabled }" style="color: #4b5563">전체파일저장</button>
                    <button @click.stop="triggerFileInput" class="upload-button mr-3" :class="{ disabled: disabled }">파일선택</button>
                </template>
                <span class="file-count">
                    {{ selectedFiles.length }}
                    <span v-if="deletedCount > 0">
                        ( -<span v-if="deletedCount > 0" style="color: red">{{ deletedCount }}</span> )
                    </span>
                    건
                </span>
            </div>
        </div>

        <div class="selected-items-container" :style="{ height: props.height }" :title="fileIdRef" @dragover.prevent @dragleave.prevent @drop.prevent="handleDrop" :class="{ 'drag-over': isDragging && isDnDEnabled }">
            <div v-if="selectedFiles.length === 0 && isDnDEnabled" class="drop-message">
                파일을 이곳에 드래그하거나 <button @click="triggerFileInput" class="upload-button ml-2 mr-0.5" :class="{ disabled: disabled }">파일선택</button>을 클릭하여 첨부하세요.
            </div>
            <div v-for="(file, index) in selectedFiles" :key="file.id" class="selected-item">
                <span class="item-text" @click="file.uploaded && !file.delete ? handleFilePreview(file.filename) : null" :class="{ 'hover-effect': file.uploaded && !file.delete, 'deleted-file': file.delete }" :title="file.name">
                    {{ file.name }} <span v-if="!file.uploaded">({{ file.size }}KB)</span>
                </span>
                <button v-show="file.filename" class="down-button" @click.stop="downloadFiles(file.filename)">
                    <span v-if="!file.delete"><i class="pi pi-download"></i></span>
                </button>
                <template v-if="!isReadonly">
                    <button @click="removeFile(index, file.uploaded, !file.delete)" class="remove-button" :disabled="disabled">
                        <span v-if="file.delete">
                            <i class="pi pi-undo"></i>
                        </span>
                        <span v-else> X </span>
                    </button>
                </template>
            </div>
        </div>
        <div v-if="!props.single" class="upload-container">
            <input ref="fileInput" type="file" :id="inputId" multiple class="hidden" accept=".pdf,.jpeg,.jpg,.png" @change="handleFileSelect" :disabled="disabled || isReadonly" />
        </div>
        <div v-if="props.single" class="upload-container">
            <input ref="fileInput" type="file" :id="inputId" class="hidden" accept=".pdf,.jpeg,.jpg,.png" @change="handleFileSelect" :disabled="disabled || isReadonly" />
        </div>
    </div>
</template>

<style scoped>
.header-container {
    user-select: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.25rem;
}

.required-asterisk {
    color: #f87171; /* 빨간색 */
    margin-left: 0.2rem;
    position: relative;
    top: -0.2rem;
}

.label {
    font-family: 'SCoreDream600';
    display: flex;
    color: #35424a;
    /* justify-content: space-between; */
    align-items: center;
    margin-bottom: 0.25rem;
    margin-left: 0.25rem;
    height: 1.3rem;
    user-select: none;
}

.validation-message {
    color: #f87171;
    font-size: 0.75rem;
    margin-left: 0.5rem;
}

.error-border {
    border: 1px solid red !important;
    border-radius: 0.5rem;
}

.file-count {
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    color: #4b5563;
}

.upload-container {
    width: 100%;
}

.upload-button {
    /* padding: 0.5rem 1rem; */
    /* background-color: white; */
    color: #0038ea;
    /* border: 0.1rem solid #d1d5db; */
    /* border-radius: 0.5rem; */
    cursor: pointer;
    font-family: 'SCoreDream500';
    font-size: 0.875rem;
    text-align: center;
    transition: background-color 0.2s;
}

.upload-button:hover {
    font-family: 'SCoreDream600';
}

.upload-button.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.select-count {
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    opacity: 0.9;
    display: flex;
    align-items: center;
    /* justify-content: flex-end; */
    margin-right: 0.25rem;
}

.removeall-button {
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    opacity: 0.8;
    cursor: pointer;
    margin-right: 1rem;
    border: none;
    background: none;
}

.removeall-button:hover {
    opacity: 1;
}

.selected-items-container {
    user-select: none;
    display: flex;
    flex-wrap: wrap;
    gap: 0.2rem;
    margin-top: 0.1rem;
    overflow-y: auto;
    padding: 0.5rem 0.4rem;
    border: 0.1rem solid #d1d5db;
    border-radius: 0.5rem;
    justify-content: flex-start;
    align-content: flex-start;
    width: 100%;
    /* max-width: 50rem; */
    box-sizing: border-box;
    transition: all 0.3s ease;
}

.selected-item {
    border: 0.1rem solid #d1d5db;
    padding: 0.6rem;
    border-radius: 0.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    height: 2rem;
    margin-right: 0.2rem;
    margin-bottom: 0.2rem;
    width: 100%; /* calc(33.33% - 0.35rem); */
    box-sizing: border-box;
}

.item-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
    margin-left: 0.3rem;
}

.selected-items-container.drag-over {
    background-color: #f0f4ff;
    border-color: #0038ea;
}

.drop-message {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    color: #888;
    font-size: 0.875rem;
    font-family: 'SCoreDream400';
    text-align: center;
}

/* .item-text:hover {
    text-decoration: underline;
    color: #0038ea;
} */

.remove-button {
    margin-left: 0.5rem;
    color: red;
    width: 0.5rem;
    font-family: 'SCoreDream400';
    font-size: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: none;
    border: none;
    margin-right: 0.2rem;
}

.remove-button:hover {
    font-family: 'SCoreDream600';
}

.remove-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.down-button {
    margin-left: 0.5rem;
    color: #0038ea;
    width: 0.5rem;
    font-family: 'SCoreDream400';
    font-size: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: none;
    border: none;
    margin-right: 0.6rem;
}

.down-button:hover {
    font-family: 'SCoreDream600';
}

.down-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.hover-effect:hover {
    text-decoration: underline;
    color: #0038ea;
    cursor: pointer;
}

.deleted-file {
    text-decoration: line-through;
    color: #888;
    cursor: default;
}

.selected-items-container::-webkit-scrollbar {
    width: 0.5rem;
}

.selected-items-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 8px;
}

.selected-items-container::-webkit-scrollbar-thumb {
    background: #c9c6c6;
    border-radius: 8px;
}

.selected-items-container::-webkit-scrollbar-thumb:hover {
    background: #727272;
}
</style>
